module.exports = __webpack_public_path__ + "img/Frame 1061one.979594f6.png";